import type { MarketplaceEntry } from "../types/index";
import { isRecentlyDiscovered, NEW_WINDOW_DAYS } from "../lib/recency";
import styles from "./NewBadge.module.css";

const TITLE =
  `Added to the marketplace in the last ${NEW_WINDOW_DAYS} days — few votes and no usage figure yet is normal`;

/**
 * "New" pill for entries first catalogued in the last 30 days (issue #620).
 *
 * Renders nothing for older entries, mirroring OfficialBadge — so a caller can drop
 * it beside the type badge unconditionally and the layout stays put either way.
 *
 * The point is not novelty for its own sake: #620 exists because a new entry with no
 * votes and no usage figure looks WORSE than an established one, when in fact nothing
 * is wrong with it. The tooltip says so explicitly, because the badge alone only tells
 * you the entry is new — not that its empty signals are expected.
 *
 * Shown on cards, list rows and the detail page from ONE derivation (lib/recency), so
 * the three cannot disagree about the window.
 */
export default function NewBadge({ plugin }: { plugin: MarketplaceEntry }) {
  if (!isRecentlyDiscovered(plugin.firstDiscoveredAt)) return null;
  return (
    <span className={styles.badge} title={TITLE}>
      New
    </span>
  );
}